const apiUrl = process.env.VUE_APP_HP_DPT_API;

export default {
  getPublicFilePath(fileName) {
    return `${apiUrl}/file/public/${fileName}`;
  }
};
